var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('div',{ref:"contextmenu",staticClass:"fly-context-menu",class:_vm.classes,style:(_vm.positionContextMenu)},[_c('ContextMenu',{attrs:{"size":320}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }